import { css } from 'styled-components';
import { media } from '../../../helpers/mixins';
import { PURPLE_TEXT } from '../../../constants/colors';

export default {
  wrapper: css`
    display: none;
    position: relative;
    width: 100%;
    height: 0;
    z-index: -1;

    ${media.switchHeaderToDesktop`
      display: block;
    `};
  `,
  diagonalWrapper: ({ backgroundColor, height }) => css`
    position: absolute;
    width: 100%;
    top: 0;
    background-color: ${backgroundColor || PURPLE_TEXT};
    height: ${Math.max(height - 233, 0)}px;
  `,
  triangle: ({ backgroundColor, height }) => css`
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 233px 100% 0 0;
    border-color: ${backgroundColor || PURPLE_TEXT} transparent transparent transparent;
    top: ${Math.max(height - 233, 0)}px;
  `
};
